// 订单状态
const ORDER_STATUS = {
    ORDER_RECEIVE_SUCCESS: 50, // 接单成功
    ORDER_RECEIVE_FAIL: 75, // 接单失败
    ADD: 100, // 新增
    CHECK_FAILED: 199, // 审核失败
    ORDER_CHECKED: 200, // 已审核
    OUTLET_ORDER: 220, // 网点接单
    WAITDELIVER: 240, // 待发货
    WAITDISPATCH: 250, // 待调车
    WAIT_FOR_RECEIVING: 255, // 待收货
    HAS_ISSUED: 260, // 已下发
    TUNED: 300, // 已调车
    ARRIVED: 310, // 已到车
    PLAY_SINGLE: 320, // 打单
    PARTIAL_DELIVERY: 345, // 部分发货
    SHIPPED: 350, // 已发货
    HAS_STARTED: 370, // 已发车
    TO_BE_RECEIVED: 375, // 待收货
    ALLOCATE_WH_SHUNTING: 410, // 分拨仓调车
    ALLOCATE_WH_IN_TRANSIT: 450, // 分拨仓在途
    HAVE_ARRIVED: 605, // 已抵达
    PART_SIGN_FOR: 680, // 部分签收
    SIGN_FOR: 690, // 签收
    USER_REJECTS: 740, // 用户拒收
    LOST: 750, // 丢件
    PARTIAL_STORAGE: 860, // 部分入库
    ORDER_CLOSED: 880, // 关闭
    WRITE_OFF: 987, // 冲销
    INTERCEPTION_FAILURE: 997, // 拦截失败
    INTERCEPTION_SUCCESS: 998, // 在途拦截
    ORDER_CANCEL: 999, // 取消订单
    EXPENSES_INCURRED: 1000 // 已产生费用批
};

// 订单类型
const ORDER_TYPE = {
    YS: 'YS', // 纯运输订单
    PO: 'PO', // 销售出库
    RI: 'RI', // 退货入库单
    RRI: 'RRI', // 拒收入库单
    ADI: 'ADI', // 数量调整入库单
    ADO: 'ADO', // 数量调整出库单
    DO: 'DO', // 分拨单
    AO: 'AO', // 调拨出库
    TFI: 'TFI', // 状态调整入库
    TFO: 'TFO', // 状态调整出库
    PI: 'PI', // 采购入库
    AI: 'AI', // 调拨入库单
    TF: 'TF', // 状态调整单
    DP: 'DP', // 上门取件单
    JDPI: 'JDPI', // 基地采购入库
    TO: 'TO', // 中转退货出库
    TI: 'TI', // 中转入库单
    RDO: 'RDO', // 中转单
    RO: 'RO', // 退货出库单
    DPRI: 'DPRI' // 上门取件退货单
};

// 业务模式
const BUSINESSMODE = {
    B2B: 'B2B', // 2B
    B2C: 'B2C' // 2C
};

// 订单来源
const ORDER_SOURCE = {
    HANDLE: 'HANDLE', // 手工
    VIEW: 'VIEW' // 视图
};

const APART_TYPE = {
    APART_TYPE_HANDLE: 'HANDLE', // 手工
    APART_TYPE_VIEW: 'VIEW' // 视图
};

const APART_STATUS = {
    PART: 'PART', // 部分拆单
    NOT_APART: 'NOT_APART', // 未拆单
    APART: 'APART' // 已拆单完成
};

// 审核状态
const EXCUTE_STATUS = {
    ADD: 100, // 新增
    CHECK: 200, // 审核
    EXCEPTION: 199, // 异常
    CLOSED: 880, // 关闭
    INTERCEPT: 998, // 拦截
    CANCEL: 999 // 取消
};

// 任务类型
const TASK_TYPE = {
    YS: 'YS', // 运输
    OUT: 'OUT', // 出库任务
    DI: 'DI', // 分拨入库
    DO: 'DO', // 分拨出库
    IN: 'IN', // 入库任务
    TF: 'TF',
    TFI: 'TFI',
    TFO: 'TFO',
    ADO: 'ADO',
    ADI: 'ADI',
    RDI: 'RDI', // 中转入库
    RDO: 'RDO', // 中转出库,
    COLLECT: 'COLLECT' // 揽收任务
};

// 来源系统
const SOURCE_SYSTEM = {
    XIAOMI: 'XiaoMi', // 小米
    CAINIAO: 'CAINIAO', // 菜鸟
    TMALL: 'TMALL', // 天猫
    KS: 'KS', // 快手
    TTX: 'TTX', // 通天晓
    PDD: 'PDD', // 拼多多
    ECM: 'ECM',
    CIMS: 'CIMS',
    CCS: 'CCS',
    CVTE: 'CVTE', // 视源
    SCC: 'SCC',
    OFC: 'OFC', // 履约中心
    QIMEN: 'QiMen',
    ELECTROLUX: 'ELECTROLUX', // 伊莱克斯
    MRP: 'MRP', // 美的零售平台
    KUKA: 'KUKA'
};

// 配送方式
const DELIVERY_TYPE = {
    ZT: 'ZT', // 自提
    YS: 'YS', // 运输
    WAREHOUSEMATCHING: 'WAREHOUSEMATCHING', // 直配
    NET_MATCHING: 'NET_MATCHING', // 网点直配
    DELIVERY: 'DELIVERY', // 配送
    EXPRESS: 'EXPRESS', // 快递
    NET: 'NET', // 网点配送
    DOT: 'DOT', // 宅配
    POGS: 'PO-GS' // 国苏直营
};

// 调整状态
const APPLY_STATUS = {
    ADD: 10, // 新增
    APPLY_FOR: 20, // 申请
    APPLY_FAILED: 50 // 申请失败
};

// 订单异常类型
const ORDER_EXCEPTION_TYPE = {
    INVENTORY_INSUFFICIENT: 'INVENTORY_INSUFFICIENT',
    RECEIVER_ADDRESS_FAILED: 'RECEIVER_ADDRESS_FAILED',
    SENDER_ADDRESS_FAILED: 'SENDER_ADDRESS_FAILED',
    NOT_APART_INVENTORY_INSUFFICIENT: 'NOT_APART_INVENTORY_INSUFFICIENT'
};

// hold单标识
const HOLD_FALG = {
    AGING: 0, // 根据接单时间
    TIME: 1, // 根据期望送达时间
    VOLUME: 2, // 体积
    COUNT: 3, // 件数
    VOLUME_TIME: 4, // 体积和时间
    FLOW_CONTROL: 5, // 流量控制
    OVER_SEVEN_DAY: 6 // 超七天
};

// flag标识
const DICT_FLAG = {
    ONE: 1,
    ZERO: 0,
    YES: 'Y',
    NO: 'N'
};

// 协同类型
const JOIN_TYPE = {
    SHARE_2O: 'SHARE_2O', // 美云销货权转移
    TRANS_INV: 'TRANS_INV' // 货权转移
};

const OTP_SERVICE_TYPE = { // 服务类型
    INSTALL_SERVICE_ORDER: 'ST120000102' // 安装增值服务单
};

const VALUED_STAUS = { // 服务单状态
    VALUED_ADD: 10, // 新增
    EXCEPTION: 15, // 异常
    VALUED_WAIT_SEPARATE_WH: 20, // 待分仓
    VALUED_PART_SEPARATE_WH: 22 // 部分分仓
};

// 前置预约类型
const PRE_APPOINTMENT_TYPE = {
    VOICE: 'VOICE' // 语音预约
};

// 前置预约状态
const PRE_APPOINT_STATUS = {
    APPOINTMENT_SUCCESS: 4 // 预约成功
};

// 运输系统
const TRANSPORT_SYSTEM = {
    CMM: 'DPS' // 车满满
};

const PAGE_TOTAL = 10000; // 异步查询总数默认值
const DEFAULT_DAY = 2; // 默认查询3天

const SEARCH_TIME_LIMIT = {
    MAX_DAY: 62 * 24 * 60 * 60 * 1000, // 查询最大天数限制
    MAX_MONTH: '两',
    MAX_INPUTSELECT_LIMIT: 100 // 批量查询最大条数
};
// 项目分类
const PROJECT_CLASSIFY = {
    CLOUD_WH_FLAG: 'CLOUD_WH_FLAG', // 云仓订单
    CDCM_FICTITIOUS: 'CDCM_FICTITIOUS', // 虚拟商品标识
    JHLP: 'JHLP', // 金华揽配
    LW: 'LW' // 菱王电梯
};
// 改约原因
const APPOINT_REASON = {
    LOGISTICS_REASON: '10',
    CUSTOMER_REASON: '20'
};

export default {
    PAGE_TOTAL,
    SEARCH_TIME_LIMIT,
    ORDER_STATUS,
    ORDER_TYPE,
    EXCUTE_STATUS,
    TASK_TYPE,
    SOURCE_SYSTEM,
    APPLY_STATUS,
    ORDER_EXCEPTION_TYPE,
    ORDER_SOURCE,
    APART_TYPE,
    APART_STATUS,
    DICT_FLAG,
    HOLD_FALG,
    DELIVERY_TYPE,
    BUSINESSMODE,
    JOIN_TYPE,
    OTP_SERVICE_TYPE,
    VALUED_STAUS,
    PRE_APPOINTMENT_TYPE,
    PRE_APPOINT_STATUS,
    TRANSPORT_SYSTEM,
    DEFAULT_DAY,
    APPOINT_REASON,
    PROJECT_CLASSIFY
};
